import script from "./Organization.vue?vue&type=script&setup=true&lang=js"
export * from "./Organization.vue?vue&type=script&setup=true&lang=js"

import "./Organization.vue?vue&type=style&index=0&id=4045c1d4&lang=css"

const __exports__ = script;

export default __exports__